import React from "react";
import Contatoform from "../../components/Contatoform";

const index = (props) => {
  return <Contatoform />;
};

export default index;